/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */

export type EngagementFieldAvailability =
  (typeof EngagementFieldAvailability)[keyof typeof EngagementFieldAvailability];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EngagementFieldAvailability = {
  AVAILABLE: 'AVAILABLE',
  INCOMPLETE: 'INCOMPLETE',
  COMING_SOON: 'COMING_SOON',
} as const;
